<mat-horizontal-stepper (selectionChange)="voltarParaContratos($event)" [selectedIndex]="2" [linear]="false" #stepper>
  <mat-step [editable]="true" [completed]="true">
    <ng-template matStepLabel>Contrato</ng-template>
  </mat-step>

  <mat-step [editable]="true" [completed]="true">
    <ng-template matStepLabel matStepperIcon="edit" let-index="index">
      <span>
        Parcela
      </span>
    </ng-template>
  </mat-step>

  <mat-step [editable]="false" [completed]="true">
    <ng-template matStepLabel>2ª via</ng-template>
  </mat-step>
</mat-horizontal-stepper>

<div *ngIf="segundaVia" class="boleto-container" [class.no-banqi]="!showBanqi">
  <app-boleto-parcela 
    [showAlert]="showAlertBoleto"
    [dadosBoleto]="segundaVia"
    (downloadBoleto)="downloadBoleto()"
    [disabledSms]="disabledSms"
    [disabledEmail]="disabledEmail"
    [permitirPagamentoPix]="permitirPagamentoPix"
    (enviarBoleto)="enviarBoletoEmailSms($event)"
    (pagarPix)="pagarEntradaComPix()">
  </app-boleto-parcela>

  <app-banqi [show]="showBanqi"></app-banqi>
</div>

<div *ngIf="segundaVia" class="final-actions">
  <h2>Podemos ajudar em mais alguma coisa?</h2>
  <button mat-raised-button color="primary" (click)="irParaGerarNovaParcela()">
  <mat-icon>refresh</mat-icon>
    Desejo Gerar outra parcela!
  </button>
</div>

